$.fn.EmbedContainer = function() {
  let self = this
  self.player = undefined
  self.viewer = self.parent()
  self.row = self.closest('.video-row')
  self.status = 0
  self.resize_timeout = undefined

  if (self.data('embed-container')) {
    return self.data('embed-container')
  }

  self.clicked = function() {
    if (self.status == 0) {
      if (self.player != undefined) {
        self.player.postMessage(JSON.stringify({
          method: 'setVolume',
          value: 1,
        }), '*')
      }
      self.status = 1;
    } else if (self.status == 1) {
      self.status = 0
      if (self.player != undefined) {
        self.player.postMessage(JSON.stringify({
          method: 'setVolume',
          value: 0,
        }), '*')
      }
    }
  }

  self.calculate_ratio = function() {
    $('body').addClass('--resizing')
    clearTimeout(self.resize_timeout)
    self.resize_timeout = setTimeout(function() {
      $('body').removeClass('--resizing')
    }, 200)
    requestAnimationFrame(function() {
      let baseRatio = .5625,
      currentRatio = self.viewer.outerHeight(false) / self.viewer.outerWidth(false)
      if (currentRatio > baseRatio) {
        self.css({
          height: '100%',
          top: '0%',
          width: (100 * currentRatio / baseRatio) + '%',
          left: (-((100 * currentRatio / baseRatio) - 100) / 2) + '%',
        })
      } else {
        self.css({
          width: '100%',
          left: '0%',
          height: (100 * baseRatio / currentRatio) + '%',
          top: (-((100 * baseRatio / currentRatio) - 100) / 2) + '%',
        })
      }
    })
  }

  return function() {
    self.data('embed-container', self)
    if (self.find('> iframe').length) {
      self.player = self.find('> iframe').get(0).contentWindow
    }
    $(window).on('resize orientationchange load', self.calculate_ratio)
    self.calculate_ratio()
    self.on('click', self.clicked)
    return self
  }()
}
